import { useBook3 } from '@orientaction/hooks_book';
import EbookReaderLayout from './components/EbookReaderLayout';
import Step3Content from './components/Step3Content';
import { useLegacyEbookReader } from './hooks/useLegacyEbookReader';

const EbookDevStep3 = () => {
  const { initValue, getMyValueBook, setId } = useBook3();
  const reader = useLegacyEbookReader({
    getMyValueBook,
    hydrateValue: initValue,
    setId,
  });

  return (
    <EbookReaderLayout {...reader} ebookName="l’Étape 3">
      {(readOnly) => <Step3Content readOnly={readOnly} />}
    </EbookReaderLayout>
  );
};

export default EbookDevStep3;
